import { useState } from 'react'
import Select from 'react-select'

import SelectStyles from '../../../shared/css/SelectStyle'
import Button from '../../../shared/components/Button/Button'
import FormLayout from '../../../shared/components/FormLayout/FormLayout'
import './ColorReportPicker.css'

function ColorReportPicker({ providers, btCancelAction }) {
    const [provider, setProvider] = useState(null)

    function generate() {
        if (!provider) return
        window.open(`/color/report/${provider._id}`, '_blank')
        btCancelAction()
    }

    return (
        <FormLayout
            title="Relatório por Fornecedor"
            actions={
                <>
                    <Button variant="print" onClick={generate} disabled={!provider}>Gerar Relatório</Button>
                    <Button variant="cancel" onClick={btCancelAction}>Cancelar</Button>
                </>
            }
        >
            <p className="crp-hint">Escolha o fornecedor pra gerar um relatório em PDF com os tecidos, cores e preços cadastrados pra ele.</p>
            <div className="form-group">
                <label className="input-label">Fornecedor:</label>
                <Select
                    options={providers}
                    styles={SelectStyles}
                    onChange={setProvider}
                    value={provider}
                    placeholder="Selecione..."
                    menuPortalTarget={document.body}
                    menuPosition="fixed"
                />
            </div>
        </FormLayout>
    )
}

export default ColorReportPicker
